import { Routes } from '@angular/router';

import { ShellComponent } from './core/layout/shell/shell.component';
import { HomePageComponent } from './features/home/pages/home-page/home-page.component';
import { ApprofondimentoPageComponent } from './features/approfondimento/pages/approfondimento-page/approfondimento-page.component';
import { MyAreaPageComponent } from './features/user-init/pages/user-published-data/user-init-page.component';
import { UserDecisionComponent } from './features/user-init/pages/user-decision/user-decision.component';
import { EntityWizardPageComponent } from './features/entity-wizard/pages/entity-wizard-page/entity-wizard-page.component';
import { UserReqComponent } from './features/user-init/pages/user-req/user-req.component';
import { authGuard } from './core/guards/auth.guard';
import { RegisterComponent } from './core/auth/register/register.component';
import { NuovoEntePageComponent } from './core/auth/register/nuovo-ente-page.component';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthServiceService } from './core/services/auth-service/auth-service.service';
import { PrivacyPolicyPageComponent } from './features/privacy/pages/privacy-policy-page/privacy-policy-page.component';
import { CookiePolicyComponent, TermsConditionsComponent } from '@mic-ac/ui-kit';

export const user: ResolveFn<any> = () => {
  const userService = inject(AuthServiceService);
  return userService.user()?.element.micAuthorized
};

export const routes: Routes = [

  {
    path: '',
    component: ShellComponent,
    data: { breadcrumb: 'Home' },

    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomePageComponent, data: { shellLayout: 'map' } },
      { path: 'approfondimento', component: ApprofondimentoPageComponent, data: { shellLayout: 'landing', breadcrumb: 'Approfondimento', hideFooterBackToTop: true } },
      { path: 'register', component: RegisterComponent },
      { path: 'register/nuovo-ente', component: NuovoEntePageComponent },
      { path: 'privacy-policy', component: PrivacyPolicyPageComponent },
      { path: 'cookie-policy', component: CookiePolicyComponent },
      { path: 'termini-condizioni', component: TermsConditionsComponent },
      {
        path: 'mp',
        children: [
          {
            path: 'my-area',
            data: { breadcrumb: 'Area Personale', shellLayout: 'landing' },
            canActivate: [authGuard],
            component: UserDecisionComponent,
            children: [
              { path: 'step-wizard', component: EntityWizardPageComponent, data: { breadcrumb: 'Richieste' } }
            ],
          },
        ],
      },
      { path: '**', redirectTo: 'home' },
    ],
  },
];
export default routes;
